/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-09-27 10:33:30
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Stack, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = WithI18nProps & {};

class ActionsGroup extends Component<Props> {
  render() {
    const { i18n } = this.props;
    return (
      <Stack>
        <Button
          primary
          onClick={() => {
            history.push(routes.recommendationWidgets.new());
          }}>
          {i18n.translate('AdminHTML.Recommendation.Common.buttonAddNew')}
        </Button>
      </Stack>
    );
  }
}

export default withI18n()(ActionsGroup);
